import angular from "angular";
import ChoosePlanModal from "./choose-plan-modal/choose-plan-modal";

const ChoosePlanModule = angular
  .module("modules.choosePlan", [])
  .component("choosePlanModal", ChoosePlanModal);

export default ChoosePlanModule;
